"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function set(target, property, value, receiver) { if (typeof Reflect !== "undefined" && Reflect.set) { set = Reflect.set; } else { set = function set(target, property, value, receiver) { var base = _superPropBase(target, property); var desc; if (base) { desc = Object.getOwnPropertyDescriptor(base, property); if (desc.set) { desc.set.call(receiver, value); return true; } else if (!desc.writable) { return false; } } desc = Object.getOwnPropertyDescriptor(receiver, property); if (desc) { if (!desc.writable) { return false; } desc.value = value; Object.defineProperty(receiver, property, desc); } else { _defineProperty(receiver, property, value); } return true; }; } return set(target, property, value, receiver); }

function _set(target, property, value, receiver, isStrict) { var s = set(target, property, value, receiver || target); if (!s && isStrict) { throw new Error('failed to set property'); } return value; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ContentShareConstants_1 = require("../contentsharecontroller/ContentShareConstants");

var VideoPreference_1 = require("./VideoPreference");

var VideoPreferences_1 = require("./VideoPreferences");

var VideoPriorityBasedPolicy_1 = require("./VideoPriorityBasedPolicy");

var VideoAdaptiveProbePolicy = /*#__PURE__*/function (_VideoPriorityBasedPo) {
  _inherits(VideoAdaptiveProbePolicy, _VideoPriorityBasedPo);

  var _super = _createSuper(VideoAdaptiveProbePolicy);

  function VideoAdaptiveProbePolicy(logger) {
    var _thisSuper, _this;

    _classCallCheck(this, VideoAdaptiveProbePolicy);

    _this = _super.call(this, logger);
    _this.logger = logger;

    _set((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(VideoAdaptiveProbePolicy.prototype)), "shouldPauseTiles", false, _thisSuper, true);

    _this.videoPreferences = undefined;
    return _this;
  }

  _createClass(VideoAdaptiveProbePolicy, [{
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "reset", this).call(this);

      _set(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "shouldPauseTiles", false, this, true);

      this.videoPreferences = undefined;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(videoIndex) {
      _get(_getPrototypeOf(VideoAdaptiveProbePolicy.prototype), "updateIndex", this).call(this, videoIndex);

      var newPreferences = VideoPreferences_1.VideoPreferences.prepare();
      var containsContent = false;
      var remoteInfos = videoIndex.remoteStreamDescriptions(); // If there is active content then set that as high priority, and the rest at lower

      var _iterator = _createForOfIteratorHelper(remoteInfos),
          _step;

      try {
        var _loop = function _loop() {
          var info = _step.value;

          // I don't know why we need to do this duplicate check.
          if (!newPreferences.some(function (preference) {
            return preference.attendeeId === info.attendeeId;
          })) {
            // For now always subscribe to content even if higher bandwidth then target
            if (info.attendeeId.endsWith(ContentShareConstants_1.default.Modality)) {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 1));
              containsContent = true;
            } else {
              newPreferences.add(new VideoPreference_1.default(info.attendeeId, 2));
            }
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (containsContent) {
        this.videoPreferences = newPreferences.build();
        this.videoPreferencesUpdated = true;
      } else {
        this.videoPreferences = undefined;
      }
    }
    /**
     * [[VideoAdaptiveProbePolicy]] does not allow setting video preferences and this function
     * will be a no-op.  Please use [[VideoPriorityBasedPolicy]] directly if you would like to set
     * preferences.
     */

  }, {
    key: "chooseRemoteVideoSources",
    value: function chooseRemoteVideoSources(_preferences) {
      this.logger.error('chooseRemoteVideoSources should not be called by VideoAdaptiveProbePolicy');
      return;
    }
  }]);

  return VideoAdaptiveProbePolicy;
}(VideoPriorityBasedPolicy_1.default);

exports.default = VideoAdaptiveProbePolicy;